/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamPlannerDto } from '../../models/team-planner-dto';
import { UpdateTeamPlannerRequest } from '../../models/update-team-planner-request';

export interface UpdateTeamPlanner$Params {
  id: string;
      body: UpdateTeamPlannerRequest
}

export function updateTeamPlanner(http: HttpClient, rootUrl: string, params: UpdateTeamPlanner$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamPlannerDto>> {
  const rb = new RequestBuilder(rootUrl, updateTeamPlanner.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamPlannerDto>;
    })
  );
}

updateTeamPlanner.PATH = '/v0/teamPlanners/{id}';
